// extracted by mini-css-extract-plugin
export var alertIcon = "_ro-0";